import { Node } from 'slate';

export const CORRECT_ANSWERS = 'correct-answers';
export const CORRECT_ANSWER = 'correct-answer';

export type CorrectAnswersOptions = {
  isReadOnly?: boolean;
  [key: string]: any;
};

export type CorrectAnswersNode = {
  label: string;
  /** Need this in case need to add correctAnswer in side `serialize` function */
  parentNodeType?: string;
} & Node;

export type CorrectAnswerNode = {
  placeholder: string;
  correctAnswer: string;
  /** For any element has same id. Required */
  forId: string;
  /** Show order number or not. Default is true */
  showOrder?: boolean;
  answerType?: 'text' | 'dropdown';
} & Node;
